/**
 * IndexedDB管理
 * Dexie.jsを使用してカルテデータを保存
 */
import Dexie, { Table } from 'dexie'
import type { PatientRecord } from 'shared'

export class KarteDatabase extends Dexie {
  patients!: Table<PatientRecord, string>

  constructor() {
    super('KarteDB')

    this.version(1).stores({
      // インデックス定義: id（プライマリキー）, createdAt, updatedAt
      patients: 'id, createdAt, updatedAt',
    })

    this.version(2).stores({
      // インデックス定義: syncedToSalonBoardを追加
      patients: 'id, createdAt, updatedAt, syncedToSalonBoard',
    })
  }
}

// データベースインスタンスをエクスポート
export const db = new KarteDatabase()

/**
 * 患者レコードを保存
 */
export const savePatientRecord = async (record: PatientRecord): Promise<string> => {
  const id = await db.patients.put(record)
  console.log('Patient record saved:', id)
  return id
}

/**
 * 最新の患者レコードを取得
 */
export const getLatestPatientRecord = async (): Promise<PatientRecord | undefined> => {
  const records = await db.patients.orderBy('createdAt').reverse().limit(1).toArray()
  return records[0]
}

/**
 * すべての患者レコードを取得
 */
export const getAllPatientRecords = async (): Promise<PatientRecord[]> => {
  return await db.patients.orderBy('createdAt').reverse().toArray()
}

/**
 * 未同期の患者レコードを取得
 */
export const getUnsyncedPatientRecords = async (): Promise<PatientRecord[]> => {
  const allRecords = await db.patients.orderBy('createdAt').reverse().toArray()
  return allRecords.filter((record) => !record.syncedToSalonBoard)
}

/**
 * 患者レコードの同期状態を更新
 */
export const updateSyncStatus = async (id: string, synced: boolean): Promise<void> => {
  await db.patients.update(id, {
    syncedToSalonBoard: synced,
    updatedAt: new Date(),
  })
}

/**
 * 患者レコードを削除
 */
export const deletePatientRecord = async (id: string): Promise<void> => {
  await db.patients.delete(id)
  console.log('Patient record deleted:', id)
}

/**
 * すべての患者レコードを削除
 */
export const clearAllPatientRecords = async (): Promise<void> => {
  await db.patients.clear()
  console.log('All patient records cleared')
}
